

// https://www.programiz.com/javascript/examples/intersection-two-arrays
export function performIntersection(arr1, arr2) {
  const intersectionResult = arr1.filter(x => arr2.indexOf(x) !== -1);
  return intersectionResult;
};

export function anyCommonElements(arr1, arr2) {
  return performIntersection(arr1, arr2).length > 0;
};
